{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Kampaně chatu",
      "NEW_CAMPAIGN": "Vytvořit kampaň",
      "CARD": {
        "STATUS": {
          "ENABLED": "Povoleno",
          "DISABLED": "Zakázáno"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Odeslal",
          "BOT": "Bot",
          "FROM": "od",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nejsou k dispozici žádné kampaně chatu",
        "SUBTITLE": "Spojte se se svými zákazníky pomocí proaktivních zpráv. Klikněte na 'Vytvořit kampaň' pro začátek."
      },
      "CREATE": {
        "TITLE": "Vytvořit kampaň chatu",
        "CANCEL_BUTTON_TEXT": "Zrušit",
        "CREATE_BUTTON_TEXT": "Vytvořit",
        "FORM": {
          "TITLE": {
            "LABEL": "Název",
            "PLACEHOLDER": "Zadejte název kampaně",
            "ERROR": "Název je povinný"
          },
          "MESSAGE": {
            "LABEL": "Zpráva",
            "PLACEHOLDER": "Zadejte zprávu kampaně",
            "ERROR": "Zpráva je povinná"
          },
          "INBOX": {
            "LABEL": "Vyberte schránku",
            "PLACEHOLDER": "Vyberte schránku",
            "ERROR": "Schránka je povinná"
          },
          "SENT_BY": {
            "LABEL": "Odeslal",
            "PLACEHOLDER": "Vyberte odesílatele",
            "ERROR": "Odesílatel je povinný"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Zadejte URL nebo regulární výraz",
            "ERROR": "Zadejte prosím platnou URL nebo regulární výraz",
            "URL_IS_REGEXP": "Hodnota je regulární výraz"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Čas na stránce (sekundy)",
            "PLACEHOLDER": "Zadejte čas",
            "ERROR": "Čas na stránce je povinný"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Další předvolby",
            "ENABLED": "Povolit kampaň",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Spouštět pouze během pracovní doby"
          },
          "BUTTONS": {
            "CREATE": "Vytvořit",
            "CANCEL": "Zrušit"
          },
          "API": {
            "SUCCESS_MESSAGE": "Kampaň živého chatu byla úspěšně vytvořena",
            "ERROR_MESSAGE": "Došlo k chybě. Zkuste to prosím znovu."
          }
        }
      },
      "EDIT": {
        "TITLE": "Upravit kampaň živého chatu",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Kampaň živého chatu byla úspěšně aktualizována",
            "ERROR_MESSAGE": "Došlo k chybě. Zkuste to prosím znovu."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS kampaně",
      "NEW_CAMPAIGN": "Vytvořit kampaň",
      "EMPTY_STATE": {
        "TITLE": "Nejsou k dispozici žádné SMS kampaně",
        "SUBTITLE": "Spusťte SMS kampaň pro přímé oslovení vašich zákazníků. Posílejte nabídky nebo oznamujte novinky s lehkostí. Klikněte na 'Vytvořit kampaň' pro začátek."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Dokončeno",
          "SCHEDULED": "Naplánováno"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Odesláno z",
          "ON": "dne"
        }
      },
      "CREATE": {
        "TITLE": "Vytvořit SMS kampaň",
        "CANCEL_BUTTON_TEXT": "Zrušit",
        "CREATE_BUTTON_TEXT": "Vytvořit",
        "FORM": {
          "TITLE": {
            "LABEL": "Název",
            "PLACEHOLDER": "Zadejte název kampaně",
            "ERROR": "Název je povinný"
          },
          "MESSAGE": {
            "LABEL": "Zpráva",
            "PLACEHOLDER": "Zadejte zprávu kampaně",
            "ERROR": "Zpráva je povinná"
          },
          "INBOX": {
            "LABEL": "Vyberte schránku",
            "PLACEHOLDER": "Vyberte schránku",
            "ERROR": "Schránka je povinná"
          },
          "AUDIENCE": {
            "LABEL": "Publikum",
            "PLACEHOLDER": "Vyberte štítky zákazníků",
            "ERROR": "Publikum je povinné"
          },
          "SCHEDULED_AT": {
            "LABEL": "Naplánovaný čas",
            "PLACEHOLDER": "Vyberte čas",
            "ERROR": "Naplánovaný čas je povinný"
          },
          "BUTTONS": {
            "CREATE": "Vytvořit",
            "CANCEL": "Zrušit"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS kampaň byla úspěšně vytvořena",
            "ERROR_MESSAGE": "Došlo k chybě. Zkuste to prosím znovu."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Opravdu chcete odstranit?",
      "DESCRIPTION": "Akce odstranění je trvalá a nelze ji vrátit zpět.",
      "CONFIRM": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Kampaň byla úspěšně odstraněna",
        "ERROR_MESSAGE": "Došlo k chybě. Zkuste to prosím znovu."
      }
    }
  }
}
